import React from 'react';
import moment from 'moment';

import { Day } from '../types';

import {
  baseDateFormat,
  timeShiftDateFormat,
} from '../../../../../../common/helper';

import { useTranslate } from '../../../../../../hooks';

import '../shift-and-schedule.css';

import { DateField } from '../../../../../../components';

type Props = { day: Day; style?: React.CSSProperties; onClick?: VoidFunction };

export function CellWithTime({ day, style, onClick }: Props) {
  const { translate } = useTranslate();

  return (
    <div className="time-shift-day" style={style} onClick={onClick}>
      <p className={`time-shift-day-text shift-code`} style={style}>
        {day?.code}
      </p>
      <p className={`time-shift-day-text`} style={style}>
        {moment().isSame(day?.date, 'day')
          ? translate('Today')
          : baseDateFormat(day?.date, timeShiftDateFormat)}
        {day?.isSwapped && (
          <span className="time-shift-swapped">({translate('Swapped')})</span>
        )}
      </p>
      <p className={`time-shift-day-time`} style={style}>
        {day.startTime ? (
          <DateField
            value={day.startTime}
            format={'hh:mm A'}
            offset={day?.timezone?.offset}
          />
        ) : (
          '--'
        )}{' '}
        -{' '}
        {day?.endTime ? (
          <DateField
            value={day?.endTime}
            format={'hh:mm A'}
            offset={day?.timezone?.offset}
          />
        ) : (
          '--'
        )}
      </p>
    </div>
  );
}
